<template>
    <v-content>
        <!--         Step Header         -->
        <v-row
            style="font-size: 1em; font-weight: 400; color: #212121; letter-spacing: 1px;"
            no-gutters
        >
            <v-col
                class="mx-3 text-center"
            >
                Let's personalize your taste!
            </v-col>
        </v-row>
        <v-row
            justify="center"
            style="font-size: 1.2em; font-weight: 600; color: #212121; letter-spacing: 1px;"
            no-gutters
        >
            <v-col
                class="mx-3 mt-2 text-center"
            >
                What do you want to eat?
            </v-col>
        </v-row>

        <!--       Progress Tracker      -->
        <v-row
            justify="center"
            no-gutters
        >
            <v-col
                class="mx-5 pa-0"
                cols="8"
                xs="8"
                sm="6"
                md="5"
                lg="4"
                xl="4"
            >
                <v-stepper-header
                    style="box-shadow: none;"
                >
                <v-stepper-step
                    step="1"
                    :complete="stepper > 1"
                    color="#74cf74"
                />
                <v-divider></v-divider>
                <v-stepper-step
                    step="2"
                    :complete="stepper > 2"
                    color="#74cf74"
                />
                <v-divider></v-divider>
                <v-stepper-step
                    step="3"
                    color="#74cf74"
                />
                </v-stepper-header>
            </v-col>
        </v-row>

        <!--            Input            -->
        <div
            class="bg5"
        >
            <v-row
                justify="center"
                no-gutters
            >
                <v-col
                    cols="12"
                    xs="12"
                    sm="10"
                    md="6"
                    lg="5"
                    xl="4"
                >
                    <v-row
                        justify="center"
                        class="mb-6"
                        no-gutters
                    >
                        <v-select
                            v-model="diet"
                            :items="getDiets"
                            item-text="name"
                            item-value="name"
                            label="Diet"
                            item-color="#32a852"
                            dense
                            filled
                            background-color="white"
                            height="60"
                        >
                        </v-select>
                    </v-row>
                    
                    <v-row
                        justify="center"
                        class="my-8"
                        no-gutters
                    >
                        <v-select
                            v-model="allergy"
                            :items="allergy.includes('none',0) ? ['none'] : allergyList"
                            label="Allergies"
                            item-color="#32a852"
                            multiple
                            dense
                            filled
                            background-color="white"
                            height="60"
                        >
                            <template
                                v-slot:selection="{ item, index }"
                            >
                                <v-chip
                                    v-if="index < 2"
                                >
                                    <span>
                                        {{ item }}
                                    </span>
                                </v-chip>
                                <span
                                    v-if="index === 2"
                                    class="grey--text caption"
                                >
                                    (+{{ allergy.length - 2 }} more)
                                </span>
                            </template>
                        </v-select>
                    </v-row>

                    <v-row
                        justify="center"
                        class="my-6"
                        no-gutters
                    >
                        <v-select
                            v-model="like"
                            :items="getLikes"
                            item-text="name"
                            item-value="name"
                            label="Likes"
                            item-color="#74cf74"
                            multiple
                            dense
                            filled
                            background-color="white"
                            height="60"
                        >
                            <template
                                v-slot:selection="{ item, index }"
                            >
                                <v-chip
                                    v-if="index < 2"
                                >
                                    <span>
                                        {{ item.name }}
                                    </span>
                                </v-chip>
                                <span
                                    v-if="index === 2"
                                    class="grey--text caption"
                                >
                                    (+{{ like.length - 2 }} more)
                                </span>
                            </template>
                        </v-select>
                    </v-row>
                    
        <!--          Navigation         -->
                    <v-row
                        no-gutters
                        class="mx-5"
                        justify="space-between"
                    >
                        <v-btn
                            class="btn2 mr-2"
                            @click="stepper = stepper - 1"
                            color = #74cf74
                        >
                            Back
                        </v-btn>
                        <v-btn
                            class="btn2 ml-2"
                            @click="next"
                            color = #74cf74
                            :disabled="disableStep3Next"
                        >
                            Next
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-content>
</template>

<script>
    export default {

        data: () => ({
            allergyListItems: [],
        }),

        methods: {
            next() {
                this.stepper = this.stepper + 1;
            }
        },

        computed: {
            stepper: {
                get() {
                    return this.$store.getters['data/stepper'];
                },
                set(value) {
                    this.$store.dispatch('data/updateStepper',value);
                }
            },

            diet: {
                get() {
                    return this.$store.getters['data/SUdiet'];
                },
                set(value) {
                    this.$store.dispatch('data/SUupdateDiet',value);
                }
            },

            allergy: {
                get() {
                    return this.$store.getters['data/SUallergies'];
                },
                set(value) {
                    this.$store.dispatch('data/SUupdateAllergies',value);
                }
            },

            like: {
                get() {
                    return this.$store.getters['data/SUlikes'];
                },
                set(value) {
                    this.$store.dispatch('data/SUupdateLikes',value);
                }
            },

            getDiets() {
                return this.$store.getters['data/diets'];
            },

            // dietList() {
            //     let list = [];
            //     for (let i = 0; i < this.getDiets.length; i++) {
            //         list.push(this.getDiets[i].name)
            //     }
            //     return list
            // },

            getAllergies() {
                return this.$store.getters['data/allergies'];
            }, 

            allergyList() {
                if (this.getAllergies.length <= 1) {
                    return []
                } else {
                    let list = ['none'];
                    for (let i = 0; i < this.getAllergies.length; i++) {
                        list.push(this.getAllergies[i].name)
                    }
                    return list
                }
            },

            getLikes() {
                return this.$store.getters['data/foodTypes'];
            },

            // likeList() {
            //     let list = [];
            //     for (let i = 0; i < this.getLikes.length; i++) {
            //         list.push(this.getLikes[i].name)
            //     }
            //     return list
            // },

            disableStep3Next() {
                if (this.diet == null | this.allergylength == 0 | this.like.length == 0) {
                    return true
                } else {
                    return false
                }
            },
            

        },
    }
</script>

<style scoped>
  .btn2 {
    font-family: "Noto Serif TC", serif;
    font-size: 0.9em;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
  }

  .btn3 {
    font-size: 0.9em;
    width: 100%;
    min-height: 48px;
    font-weight: 400;
    text-align: center;
  }

  a {
    text-decoration: none;
    color: #74cf74 !important;
    font-weight: 600;
  }
</style>

